import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { NAV, LEGAL_NAV, COMPANY } from "@/lib/site";

export const Footer = () => (
  <footer className="bg-[#0F172A] text-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="text-2xl font-bold tracking-tight">{COMPANY.displayName}</div>
        <p className="mt-4 text-slate-300 leading-relaxed max-w-md text-sm flex gap-2">
          <MapPin size={18} className="shrink-0 mt-0.5 text-slate-400" />
          <span>
            {COMPANY.addressLine1}, {COMPANY.addressLine2}
          </span>
        </p>
        <div className="mt-3 space-y-1 text-sm text-slate-300">
          <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-white transition-colors duration-150" data-testid="footer-email">
            <Mail size={16} className="text-slate-400" /> {COMPANY.email}
          </a>
          <a href={`tel:+${COMPANY.phoneRaw}`} className="flex items-center gap-2 hover:text-white transition-colors duration-150" data-testid="footer-phone">
            <Phone size={16} className="text-slate-400" /> {COMPANY.phoneDisplay}
          </a>
        </div>
        <p className="mt-5 text-slate-400 text-xs leading-relaxed max-w-md">
          AMFI-registered Mutual Fund Distributor · {COMPANY.arn} · EUIN {COMPANY.euin}.
          Mutual fund investments are subject to market risks; read all scheme related
          documents carefully.
        </p>
      </div>

      <div>
        <div className="font-semibold mb-4">Company</div>
        <ul className="space-y-2 text-slate-300 text-sm">
          {NAV.filter((n) => n.to !== "/").map((n) => (
            <li key={n.label}>
              <Link to={n.to} className="hover:text-white transition-colors duration-150" data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <div className="font-semibold mb-4">Legal</div>
        <ul className="space-y-2 text-slate-300 text-sm">
          {LEGAL_NAV.map((n) => (
            <li key={n.label}>
              <Link to={n.to} className="hover:text-white transition-colors duration-150" data-testid={`footer-legal-${n.to.replace("/", "")}`}>
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-slate-700">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 text-slate-400 text-xs flex flex-col md:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
        <span>Mysuru, Karnataka, India</span>
      </div>
    </div>
  </footer>
);

export default Footer;
